import { renewEnrollmentApi } from '../api'

const tryToSubmit = async (groupStudentId, degree, curriculum) => {
  try {
    let response = await renewEnrollmentApi.create(
      groupStudentId,
      degree,
      curriculum,
    )

    const { status } = response

    if (status === 200) {
      const responseBody = await response.json()

      return { success: true, jid: responseBody.jid }
    }
  } catch { }

  return { success: false, error: 'Erro ao enviar a solicitação de renovação de matrícula. Tente novamente.' }
}

const tryToCancel = async groupStudentId => {
  try {
    let response = await renewEnrollmentApi.cancel(groupStudentId)

    return {
      success: response.status === 200,
    }
  } catch { }

  return { success: false, error: 'Não foi possível cancelar a renovação de matrícula.' }
}

const get = async (user, password) => {
  try {
    const response = await renewEnrollmentApi.get(user, password)

    const { ok, status } = response

    if (ok && status === 200) {
      const responseBody = await response.json()

      return {
        success: true,
        payload: responseBody.data.map(i => i.attributes),
      }
    }
  } catch { }

  return {
    success: false,
    payload: {},
  }
}

const nextOffers = async groupStudentId => {
  try {
    const response = await renewEnrollmentApi.nextOffers(groupStudentId)

    const { ok, status } = response

    if (ok && status === 200) {
      const responseBody = await response.json()

      return {
        success: true,
        payload: responseBody.data.map(i => i.attributes),
      }
    }
  } catch { }

  return {
    success: false,
    payload: {},
  }
}

const getPdf = async (groupStudentId, reenrollmentIntentHistoryId = false) => {
  try {
    const response = await renewEnrollmentApi.getPdf(groupStudentId, reenrollmentIntentHistoryId)

    const { ok, status } = response

    if (ok && status === 200) {
      const blob = await response.blob()
      const url = window.URL.createObjectURL(blob)

      let tag = document.createElement('a')

      tag.href = url
      tag.download = `comprovante-rematricula-${groupStudentId}.pdf`

      document.body.appendChild(tag)

      tag.click()
      tag.remove()
    }
  } catch (e) {
    console.error(e)
  }
}

const checkEligibility = async groupStudentId => {
  try {
    const response = await renewEnrollmentApi.checkEligibility(groupStudentId)

    const { ok, status } = response

    if (ok && status === 200) {
      const responseBody = await response.json()

      return {
        success: true,
        payload: responseBody.data.attributes,
      }
    }
  } catch { }

  return { success: false, error: 'Não foi possível validar os dados. Tente novamente.' }
}

const search = async cpf => {
  try {
    const response = await renewEnrollmentApi.search(cpf)

    const { ok, status } = response

    if (ok && status === 200) {
      const responseBody = await response.json()

      return {
        success: true,
        payload: responseBody.data.map(i => i.attributes),
      }
    }
  } catch { }

  return {
    success: false,
    payload: {},
  }
}

const jobStatus = async (groupStudentId, jid, jobAction) => {
  try {
    const response = await renewEnrollmentApi.jobStatus(groupStudentId, jid, jobAction)

    const { status } = response
    const responseBody = await response.json()

    return {
      success: status === 200 || status === 202,
      status: status,
      payload: responseBody?.data?.attributes,
      message: responseBody?.message,
      error: responseBody?.error,
    }

  } catch { }

  return { success: false, status: 500, error: 'Erro interno do servidor', message: 'Servidor temporariamente indisponível. Tente novamente mais tarde.' }
}

const renewEnrollmentService = {
  get,
  getPdf,
  nextOffers,
  tryToSubmit,
  tryToCancel,
  checkEligibility,
  search,
  jobStatus,
}

export default renewEnrollmentService
